<template>
    <div v-if="isVisible" class="confirm-dialog">
        <div class="confirm-dialog-content">
            <label class="title" :class="{'large': !!confirmMessage}">{{ confirmTitle }}</label>

          <p class="mt-3" v-if="confirmMessage">{{ confirmMessage }}</p>

            <div class="mt-3">
                <basic-button
                    :class="['btn', 'btn-' + confirmButtonStyle]"
                    :text="confirmButtonText"
                    @click="confirm"/>
                <basic-button
                    class="btn btn-secondary"
                    :text="cancelButtonText"
                    @click="cancel"/>
            </div>
        </div>
    </div>
</template>

<script>
import BasicButton from "../atoms/BasicButton.vue";

export default {
    props: {
        value: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: trans('general.dialog.title')
        },
        message: {
            type: String,
            default: null
        },
        confirmButtonText: {
            type: String,
            default: trans('general.dialog.confirm')
        },
        confirmButtonStyle: {
            type: String,
            default: 'danger'
        },
        cancelButtonText: {
            type: String,
            default: trans('general.dialog.cancel')
        }
    },
    components: {
        BasicButton
    },
    data() {
        return {
            isVisible: this.value,
            confirmTitle: this.title,
            confirmMessage: this.message,
        };
    },
    watch: {
        value() {
            this.isVisible = this.value;
        },
        isVisible() {
            this.$emit('input', this.isVisible);
        }
    },
    methods: {
        confirm() {
            this.$emit('confirm');
            this.isVisible = false;
        },
        cancel() {
            this.$emit('cancel');
            this.isVisible = false;
        },
        show(title, message) {
            this.confirmTitle = title ?? this.confirmTitle;
            this.confirmMessage = message ?? this.confirmMessage;
            this.isVisible = true;
        }
    }
}
</script>
